export default function LatestResults() {
  const results = [
    { period: '2026/095期', date: '8月7日', numbers: [3, 12, 18, 27, 35, 42], special: 8, jackpot: '8,000,000' },
    { period: '2026/094期', date: '8月4日', numbers: [5, 14, 21, 29, 38, 45], special: 16, jackpot: '5,500,000' },
    { period: '2026/093期', date: '8月1日', numbers: [7, 11, 19, 25, 33, 41], special: 22, jackpot: '12,000,000' },
  ];

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-8 md:mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          最新开奖结果
        </h2>
        <p className="text-foreground-600 text-sm md:text-base">最近三期六合彩开奖号码与奖金信息</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {results.map((result, index) => (
          <div
            key={result.period}
            className={`bg-background-50 rounded-lg border p-5 md:p-6 ${
              index === 0 ? 'border-primary-300 ring-1 ring-primary-200' : 'border-background-200/70'
            }`}
          >
            <div className="flex items-center justify-between mb-4">
              <span className="text-sm font-medium text-foreground-800">{result.period}</span>
              <span className="text-xs text-foreground-500">{result.date}</span>
              {index === 0 && (
                <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                  最新
                </span>
              )}
            </div>
            <div className="flex flex-wrap gap-2 mb-4">
              {result.numbers.map((num) => (
                <div
                  key={num}
                  className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-bold text-sm md:text-base"
                >
                  {num}
                </div>
              ))}
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-accent-500 text-background-50 font-bold text-sm md:text-base">
                +{result.special}
              </div>
            </div>
            <div className="pt-3 border-t border-background-200/70">
              <span className="text-xs text-foreground-500">头奖奖金</span>
              <p className="text-lg md:text-xl font-heading font-bold text-primary-700">
                HK${result.jackpot}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}